import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get a list of map data versions and their counts
 * @returns An map data version by quarter
 */
export function getCompanyMapDataVersion(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.resolve(this).companyMapDataVersionUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
      })
    )
  ).pipe(
    selectData(
      z.array(
        z.object({
          mapDataVersion: z.string(),
          count: z.number(),
        })
      )
    )
  );
}
